import React from 'react';

interface SEOProps {
  title: string;
  description: string;
  type?: 'website' | 'article';
  image?: string;
  jsonLd?: object;
}

const SEO: React.FC<SEOProps> = ({
  title,
  description,
  type = 'website',
  image = '/images/logo.webp',
  jsonLd,
}) => {
  const siteUrl = 'https://betsprinto.com';
  const fullImageUrl = image.startsWith('http') ? image : `${siteUrl}${image}`;

  const defaultJsonLd = {
    '@context': 'https://schema.org',
    '@type': type === 'article' ? 'Article' : 'WebSite',
    name: title,
    description: description,
    url: siteUrl,
    image: fullImageUrl,
    publisher: {
      '@type': 'Organization',
      name: 'BetSprinto',
      logo: {
        '@type': 'ImageObject',
        url: `${siteUrl}/images/logo.webp`,
      },
    },
  };

  const finalJsonLd = jsonLd || defaultJsonLd;

  return (
    <>
      <title>{title} | BetSprinto</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:url" content={siteUrl} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImageUrl} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(finalJsonLd) }}
      />
    </>
  );
};

export default SEO;

